module.exports = __webpack_public_path__ + "assets/img/rphone.2b1bedd4.png";